import React from 'react';
import { Button, Theme } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { makeStyles, createStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 4,
      textTransform: 'none',
      fontSize: '13px',
      whiteSpace: 'nowrap',
      boxShadow: 'none',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '&:hover': {
        boxShadow: 'none',
      },
    },
  })
);

/**
 * The squared action button used across the admin console, in place of the
 * rounded TabletButton.
 */
export const ConsoleActionButton = React.forwardRef((props: ButtonProps, ref: ButtonProps['ref']) => {
  const classes = useStyles();
  const { className, children, ...rest } = props;

  return (
    <Button
      ref={ref}
      size='small'
      disableElevation
      {...rest}
      className={className ? `${classes.root} ${className}` : classes.root}
    >
      {children}
    </Button>
  );
});
